var loadPageScripts = function(page) {
    page = page ? page : 'index'; 
    
    if(page === 'contact' || page === 'register'){
        $('body').append(
            '<script type="text/javascript" src="assets/js/pages/' + page + '.min.js" data-source="ajax" defer></script>'
        );
    } 
};

var clearAjaxScripts = function() {
    $('script[data-source="ajax"]').each(function () {
        $(this).remove();
    });
};

var clearLoadScripts = function() {
    $('script[data-source="load"]').each(function () {
        $(this).remove();
    });
};

var activeNavigation = function() { 
    var mainsplit = 1;
    var profile = 3;
    var keysplit = 3;
    var pageids = 2;
    var pagetitle = '';
    var keywords = '';
    var metadesciption = '';
    var metadetails = '';
    var metaimage = ''; 

    var pathname = window.location.pathname;
    var spli    = pathname.split('/');
    var valid   = spli[mainsplit];
    var keymeta = spli[keysplit];
    var ids     = spli[pageids];


    if (typeof keymeta == "undefined") {
        keymeta = 'NONE';
    }
    if (typeof ids == "undefined") {
        ids = 'NONE';
    }

    $.ajax({
        type: 'post',
        url: 'includes/meta-tags-ajax.php',
        data: {valid : valid, keymeta : keymeta, ids : ids}, 
        dataType: 'json',
            
        success: function(data){
            //console.log(data);
            var msg = JSON.parse(JSON.stringify(data));
                //$("#error").html(msg.reason);
            if(msg.metatitle !== ''){
                pagetitle = msg.metatitle;
                $(document).prop('title', pagetitle);
                $('meta[property=og\\:title]').attr('content', pagetitle);
            } else {
                pagetitle = '';  
                $('meta[property=og\\:title]').attr('content', pagetitle);
            }
              
            if(msg.metatag !== ''){
                keywords = msg.metatag;
                $('meta[name=keywords]').attr('content', keywords);
            } else {
                keywords = '';
                $('meta[name=keywords]').attr('content', keywords);
            } 
              
            if(msg.metadescription !== ''){
                metadesciption = msg.metadescription;
                $('meta[name=description]').attr('content', metadesciption);
            } else {
                metadesciption = '';  
                $('meta[name=description]').attr('content', metadesciption);
            } 
              
            if(msg.metadetails !== ''){
                metadetails = msg.metadetails;
                $('meta[property=og\\:description]').attr('content', metadetails);
            } else {
                metadesciption = msg.metadescription;
                $('meta[property=og\\:description]').attr('content', metadesciption);
            }
              
            // var fso  = new ActiveXObject("Scripting.FileSystemObject");   
            // if (!fso.FolderExists(msg.metaimage)) {
            //         //alert("Folder does not exist!");
            //         //return;
            //     metaimage = 'http://fmderana.lk/image/images/etunes.jpg';
            //     $('meta[property=og\\:image]').attr('content', metaimage);
            // } else if(msg.metaimage !== null){
            //      // if (typeof metaimage == "undefined") {
            //         // metaimage = msg.metaimage;
            //         // var manageurl = metaimage.split(" ").join("%20");
            //      // }
            //     metaimage = msg.metaimage;
            //     $('meta[property=og\\:image]').attr('content', 'http://fmderana.lk/image/' + metaimage);
            // } else {
            //     metaimage = 'http://fmderana.lk/assets/images/apple-icon-touch.png';
            //     $('meta[property=og\\:image]').attr('content', metaimage);
            // }
              
            if(msg.metaimage !== null){
                metaimage = msg.metaimage;
                $('meta[property=og\\:image]').attr('content', metaimage);
            } else {
                metaimage = 'http://fmderana.lk/assets/images/apple-icon-touch.png';
                $('meta[property=og\\:image]').attr('content', metaimage);
            }
            $('meta[property=og\\:url]').attr('content', window.location);      
        },
        error: function(XMLHttpRequest, textStatus, errorThrown) { 
            console.log("Status: " + textStatus); 
            console.log("Error: " + errorThrown);
            console.log(XMLHttpRequest.responseText)
        }
    });

};

var navActive = function(lastSlug){
    $('.nav-item').removeClass('active');
    $('.navbar-nav li .inner-click').each(function(){
        if($(this).attr('href') === lastSlug){
            $(this).parent('.nav-item').addClass('active');
        }
    });
};

 
(function( $ ) {

    var loggedid = '';
    var islogged = 0;
 
    islogged = document.getElementById("paramIsUserLogged").value;

    //loggedid = document.getElementById('paramIdUserLogged');
    if (document.getElementById('paramIdUserLogged') != null) {
        loggedid = document.getElementById("paramIdUserLogged").value;
    }else {
        loggedid = 0;
    }


    $(document).ready(function(){
        var lastSlug = $(location).attr("href").split('/').pop();
        navActive(lastSlug);
    });

    $(document).on('click', 'body .inner-click', function (e) {
        e.preventDefault();
        $('.nav-item').removeClass('active');
        if($(this).hasClass('nav-link')){
            $(this).parent('.nav-item').addClass('active');
        }
        if($('.header-search').hasClass('expand')){
            $('.header-search').removeClass('expand');
            $('.header-search').find('input').val('');
            $("#suggesstion-box").fadeOut();
            $("#suggesstion-box").html(''); 
        }
        var page_url = $(this).attr('href');
        $.ajax({
            url: page_url + '?type=ajax',
            beforeSend: function() {
                $('#content-preloader').show();
            },
            complete: function() {
                $('#content-preloader').fadeOut(500);
            },
            success: function (data) {

                // clear ajax loaded scripts 
                clearLoadScripts();  
                clearAjaxScripts(); 

                $('#inner-content').html(data); 
                activeNavigation(); 

                homeBannerSetting(); 
               
                widgetSlider();
                radioItemTitleHeight();
          
                // include page specific js
                loadPageScripts(page_url);

                $(".left-column").animate({ scrollTop: 0 }, "slow");

            }

        });

        if (page_url !== window.location) {
            window.history.pushState({
                path: page_url
            }, '', page_url);
        }

    });

    $(window).on('popstate', function () {
        var lastSlug = $(location).attr("href").split('/').pop();
        navActive(lastSlug);
        if($('.header-search').hasClass('expand')){
            $('.header-search').removeClass('expand');
            $('.header-search').find('input').val('');
            $("#suggesstion-box").fadeOut();
            $("#suggesstion-box").html(''); 
        }
        $.ajax({
            url: location.pathname + '?type=ajax',
            beforeSend: function() {
                $('#content-preloader').show();
            },
            complete: function() {
                $('#content-preloader').fadeOut(500);
            },
            success: function (data) {

                // clear ajax loaded scripts 
                clearLoadScripts();  
                clearAjaxScripts(); 

                $('#inner-content').html(data); 
                activeNavigation(); 

                homeBannerSetting(); 
               
                widgetSlider();
                radioItemTitleHeight();
          
                // include page specific js
                loadPageScripts(location.pathname);

                $(".left-column").animate({ scrollTop: 0 }, "slow");

            }
        });
    });


    activeNavigation();

    $('#loginForm').submit(function(e){
        e.preventDefault();
        $("#login-error").html('');
        $(this).valid();

    });

    $('#loginForm').validate({
        ignore: [],
        rules: {
            email: {
                required: true,
                customEmail: true,
                maxlength: 100,
            },
            password: {
                required: true,
            },
            hiddenRecaptcha: {
                required: function () {
                    if (grecaptcha.getResponse() == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        errorPlacement: function(error, element) {
            if (element.parent('.input-group').length > 0) {
                element.closest('.input-group').after(error);
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {

            var email = $(form).find('input[name="email"]').val();
            var pwd = $(form).find('input[name="password"]').val();
            var csrfToken = $(form).find('input[name="csrfToken"]').val();

            $.ajax({
                type: "POST",
                url: "includes/login-exec.php",
                data: {
                    email: email,
                    pwd: pwd, 
                    token: csrfToken,
                    recaptcha: grecaptcha.getResponse()
                },
                dataType: 'json', 
                beforeSend: function() {
                    $('#loginForm').find('button[type="submit"]').text('Please wait..');
                },
                complete: function() {
                    $('#loginForm').find('button[type="submit"]').text('Login');
                },
                success: function (data) {
                    //console.log(data);
                    var msg = JSON.parse(JSON.stringify(data));
                    if (msg.success == true) { 
                        window.location.assign(msg.url);
                    } else { 
                        $("#login-error").html('<div class="alert alert-danger" role="alert">'+msg.reason+'</div>'); 
                        grecaptcha.reset();
                    }
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    console.log("Status: " + textStatus);
                    console.log("Error: " + errorThrown);
                    console.log(XMLHttpRequest.responseText)
                }
            });
            return false;
        },
    });


    $('body').click(function () {
        $.post('includes/ajax-session.php', function (data) {
            if (data == '1') {
                if (islogged == 1) {
                    alert('Your session has been expired!')
                    window.location = "index.php";
                    return;
                }
            }
        });
    });

    
    $('#forgotPasswordForm').submit(function(e){
        e.preventDefault();
        $("#forgotPassword-error").html('');
        $("#forgotPassword-success").addClass('d-none');
    });

    
    $('#forgotPasswordForm').validate({
        rules: {
            email: {
                required: true,
                customEmail: true,
                maxlength: 100,
            }
        },
        submitHandler: function (form) {

            var email = $(form).find('input[name="email"]').val();
            var csrfToken = $(form).find('input[name="csrfToken"]').val();

            $.ajax({
                type: "POST",
                url: "includes/forgot-password-exec.php",
                data: {
                    email: email,
                    token: csrfToken
                },
                dataType: 'json',
                beforeSend: function() {
                    $('#content-preloader').show();
                }, 
                complete: function() {
                    $('#content-preloader').fadeOut(500);
                },
                success: function (data) {
                    //console.log(data);        
                    var msg = JSON.parse(JSON.stringify(data));
                    if (msg.success == true) {
                        $("#forgotPassword-success").removeClass('d-none');
                        $(".left-column").animate({ scrollTop: 0 }, "slow");
                    } else {
                        $("#forgotPassword-error").html('<div class="alert alert-danger" role="alert">'+msg.reason+'</div>');
                        $(".left-column").animate({ scrollTop: 0 }, "slow");
                    }
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    console.log("Status: " + textStatus);
                    console.log("Error: " + errorThrown);
                    console.log(XMLHttpRequest.responseText);
                }
            });
            return false;
        }
    });


    $('#editProfileForm').submit(function(e){
        e.preventDefault();
        $("#edit-profile-error").html('');
        $("#edit-profile-succes").html('');
    });

    $('#editProfileForm').validate({
        rules: {
            firstname: {
                required: true,
                customText: true,
                maxlength: 100,
            },
            lastname: {
                required: true,
                customText: true,
                maxlength: 100,
            },
            country: {
                required: true,
            },
            email: {
                required: true,
                customEmail: true,
                maxlength: 100,
            },
            birthday:{
                required: true,
                birthday : true,
            },
        },
        // messages: { },
        submitHandler: function (form) {

            var firstname = $(form).find('input[name="firstname"]').val();
            var lastname = $(form).find('input[name="lastname"]').val();
            var email = $(form).find('input[name="email"]').val();
            var city = $(form).find('input[name="city"]').val();
            var country = $(form).find('#country').val();
            var gender = $(form).find('input[name="gender"]:checked').val();
            var birthday = $(form).find('input[name="birthday"]').val();
            var csrfToken = $(form).find('input[name="csrfToken"]').val();


            $.ajax({
                type: "POST",
                url: "includes/editForm.php",
                data: {
                    firstname: firstname,
                    lastname: lastname,
                    email: email,
                    city: city,
                    country: country,
                    gender: gender,
                    birthday: birthday,
                    userid: loggedid,
                    token: csrfToken
                },
                dataType: 'json',
                beforeSend: function() {
                    $('#content-preloader').show();
                }, 
                complete: function() {
                    $('#content-preloader').fadeOut(500);
                },
                success: function (data) {
                    //console.log(data);        
                    var msg = JSON.parse(JSON.stringify(data));
                    if (msg.success == true) {
                        //window.location.assign(msg.url);
                        $("#edit-profile-success").html('<div class="alert alert-success" role="alert">'+msg.reason+'</div>');
                        $(".left-column").animate({ scrollTop: 0 }, "slow");
                    } else {
                        $("#edit-profile-error").html('<div class="alert alert-danger" role="alert">'+msg.reason+'</div>');
                        $(".left-column").animate({ scrollTop: 0 }, "slow");
                    }
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    console.log("Status: " + textStatus);
                    console.log("Error: " + errorThrown);
                    console.log(XMLHttpRequest.responseText);
                }
            });
            return false;
        }
    });



    $('#pwdChangeForm').submit(function(e){
        e.preventDefault();
        $("#pwdchange-error").html('');
        $("#pwdchange-success").html('');
    });

    $('#pwdChangeForm').validate({
        rules: {
            firstname: {
                required: true,
                customText: true,
                maxlength: 100,
            },
            lastname: {
                required: true,
                customText: true,
                maxlength: 100,
            },
            email: {
                required: true,
                customEmail: true,
                maxlength: 100,
            },
            birthday:{
                required: true,
                birthday : true,
            },
            epwdinput: {
                required: true,

            },
            pwdinput: {
                required: true,
                minlength: 8,
                passwordNumber: true,
                passwordLetter: true
            },
            cpwdinput: {
                required: true,
                minlength: 8,
                equalTo: "#pwdinput",
                passwordNumber: true,
                passwordLetter: true
            } 
        },
        messages: {
            epwdinput: {
                required: "Enter current password",
            },
            pwdinput: {
                required: "Enter new password",
                minlength: "Password too short"
            },
            cpwdinput: {
                required: "Enter confirm password",
                minlength: "Password too short"
            }
        },
        submitHandler: function (form) {

            var epwd = $(form).find('input[name="epwdinput"]').val();
            var pwd = $(form).find('input[name="pwdinput"]').val();
            var cpwd = $(form).find('input[name="cpwdinput"]').val();
            var csrfToken = $(form).find('input[name="csrfToken"]').val();

            $.ajax({
                type: "POST",
                url: "includes/password-reset.php",
                data: {
                    epawd: epwd,
                    pawd: pwd,
                    cpawd: cpwd,
                    userid: loggedid,
                    token: csrfToken
                },
                dataType: 'json',
                beforeSend: function() {
                    $('#content-preloader').show();
                }, 
                complete: function() {
                    $('#content-preloader').fadeOut(500);
                },
                success: function (data) {
                    //console.log(data);        
                    var msg = JSON.parse(JSON.stringify(data));
                    if (msg.success == true) {
                        //window.location.assign(msg.url);
                        $("#pwdchange-success").html('<div class="alert alert-success" role="alert">'+msg.reason+'</div>');
                        $(".left-column").animate({ scrollTop: 0 }, "slow");
                    } else {
                        $("#pwdchange-error").html('<div class="alert alert-danger" role="alert">'+msg.reason+'</div>');
                        $(".left-column").animate({ scrollTop: 0 }, "slow");
                    }
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    alert("Status: " + textStatus);
                    alert("Error: " + errorThrown);
                    alert(XMLHttpRequest.responseText)
                }
            });
            return false;
        }
    });



    $('#profileChangeForm').submit(function(e){
        e.preventDefault();
        $("#profile-change-error").html('');
        $("#profile-change-success").html('');
    });

    $('#profileChangeForm').find('.btn-reset').on('click', function(){ 
        $('#profileChangeForm').find('.custom-file-input').next('.custom-file-label').text(' ');
    });

    $('#profileChangeForm').validate({
        rules: {
            image: {
                required: true,
                extension: "jpg|jpeg|png",
                accept: "image/jpeg, image/png",
                //filesize: 100000, //max size 100 kb
            },
        },
        errorPlacement: function(error, element) {
            if (element.hasClass('custom-file-input')) {
                element.closest('.custom-file').after(error);
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {

            //var file = $(form).find('input[name="image"].files[0
            var file = $(form).find('input[name="image"]').get(0).files[0]; 
            var csrfToken = $(form).find('input[name="csrfToken"]').val();
            var formData = new FormData();                     
            formData.append('file', file);
            formData.append('userid', loggedid);
            formData.append('token', csrfToken);

            $.ajax({
                type: "POST",
                url: "includes/picture-process.php",
                data: formData,
                dataType: 'json',
                contentType: false,
                cache: false,
                processData: false,
                beforeSend: function() {
                    $('#content-preloader').show();
                }, 
                complete: function() {
                    $('#content-preloader').fadeOut(500);
                },
                success: function (data) {
                    //console.log(data);        
                    var msg = JSON.parse(JSON.stringify(data));
                    if (msg.success == true) {
                        //window.location.assign(msg.url);
                        $("#profile-change-success").html('<div class="alert alert-success" role="alert">'+msg.reason+'</div>');
                        $(".left-column").animate({ scrollTop: 0 }, "slow");
                    } else {
                        $("#profile-change-error").html('<div class="alert alert-danger" role="alert">'+msg.reason+'</div>');
                        $(".left-column").animate({ scrollTop: 0 }, "slow");
                    }
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    alert("Status: " + textStatus);
                    alert("Error: " + errorThrown);
                    alert(XMLHttpRequest.responseText)
                }
            });
            return false;
        }
    });


    $("#filter_keyword").keyup(function (e) {
        if (e.keyCode == 27) { // escape key maps to keycode `27`
            $("#suggesstion-box").fadeOut();
            $("#suggesstion-box").html(''); 
            return;
        }
        if($(this).val().length == 0){
            $("#suggesstion-box").fadeOut();
            $("#suggesstion-box").html(''); 
            return;
        }
        var keyword = $(this).val();
        $.ajax({
            type: "POST",
            url: "includes/search/live.php",
            //data: 'keyword=' + $(this).val(),
            data: {keyword: keyword},
            beforeSend: function () {
                $("#suggesstion-box").fadeIn();
                $("#suggesstion-box").css("background-image", "url(includes/search/LoaderIcon.gif)");
            },
            complete: function(){ 
                $("#suggesstion-box").css("background-image", "none");
            },
            success: function(data) {
                $("#suggesstion-box").html(data); 
            }
        });
    });


}(jQuery));

